export enum RevenueChangeGroup {
  CHURNED = 'churnedRevenue',
  DECREASED = 'decreasedRevenue',
  INCREASED = 'increasedRevenue',
  NEW = 'newRevenue',
  NET = 'netRevenueChange',
  TOTAL = 'totalRevenue',
  SAME = 'sameRevenue',
  EXISTING = 'existingRevenue',
}
